/* =====================================================
   SUNBORN WISHLIST -- REWRITTEN 8/18.

   WHY: the original storage format was a flat array of product
   HANDLES only -- no variant info at all. Captain flagged (correctly)
   that this meant a customer who wishlists an item from the minicart
   (where a size/color is already picked) loses that selection
   entirely -- they'd land back on a generic product page later and
   have to re-pick from scratch. This rewrite changes the stored
   format from an array of strings to an array of OBJECTS:
     { handle, variantId, variantTitle, productTitle, price, image }
   still keyed/deduped by handle (one wishlist entry per PRODUCT, not
   per variant -- wishlisting a different color of something you
   already saved just updates the existing entry's variant info,
   it doesn't create a second entry), but now carrying enough to
   restore the exact variant later (needed for "Add back to cart" /
   "Buy Now" in the minicart's Saved-for-later section) and to render
   a clean thumbnail without a per-item network fetch.

   Helper functions are exposed on window.SBWishlist so OTHER scripts
   (sections/wishlist.liquid, and the minicart's Saved-for-later
   renderer in ajax-cart.liquid) can reuse the exact same read/write/
   dedupe logic instead of keeping a second, parallel copy that could
   drift out of sync -- the original file had that problem:
   wishlist.liquid had its own near-duplicate copy of this entire
   add/remove flow.

   BACK-COMPAT: normalize() treats any plain-string entry (the OLD
   format) as { handle: entry, variantId: '', ... } so nothing breaks
   if a stray old-format array is already sitting in someone's
   localStorage from testing before this fix.

   PDP LIVE-VARIANT FIX: on the PDP, the wishlist button's data-
   variant-id attribute is only accurate for whatever variant was
   selected on initial page load. If the customer changes the variant
   picker afterward (no page reload), that attribute goes stale. The
   ADD-TO-CART form already tracks the live selection in a hidden
   input, .product-variant-id (see product-template-button.liquid),
   kept in sync by Lume's native variant-picker JS. getLiveVariantId()
   piggybacks on that existing, already-correct mechanism at click
   time, rather than duplicating variant-picker logic here.

   IMAGE -- ADDED 8/18, later session. Needed for the minicart's
   Saved-for-later list to show a real thumbnail per item without
   doing a network fetch per saved product. Sourced from data-image
   on the button that added the entry (grid/PDP: product's featured
   image; minicart heart: the exact line item's own image).

   CHANGE EVENT -- ADDED 8/18, later session. Captain reported the
   minicart's Saved-for-later list didn't update immediately when a
   heart was clicked -- only after closing and reopening the drawer.
   Root cause: the minicart's render function only ever ran on page
   load, on a guessed click-delegation match, or after "Add back to
   cart" -- nothing tied it to the ACTUAL moment the data changes.
   save() now dispatches a 'sunborn:wishlist-change' event on
   window every time it runs (both add and remove go through this one
   function), so anything listening gets notified at the exact
   instant the array is written, with no timing guesswork.
   ===================================================== */

window.SBWishlist = window.SBWishlist || {};

(function () {
  function getArray() {
    try {
      var raw = localStorage.getItem('wishlist');
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function normalize(entry) {
    if (typeof entry === 'string') {
      return { handle: entry, variantId: '', variantTitle: '', productTitle: '', price: '', image: '' };
    }
    return entry || { handle: '', variantId: '', variantTitle: '', productTitle: '', price: '', image: '' };
  }

  function findIndex(arr, handle) {
    for (var i = 0; i < arr.length; i++) {
      if (normalize(arr[i]).handle === handle) return i;
    }
    return -1;
  }

  function save(arr) {
    localStorage.setItem('wishlist', JSON.stringify(arr));
    localStorage.setItem('user_wishlist_cnt', arr.length);
    try {
      window.dispatchEvent(new CustomEvent('sunborn:wishlist-change', { detail: { count: arr.length } }));
    } catch (e) {
      // CustomEvent unsupported in some very old browsers -- fail
      // silently, storage itself already succeeded above.
    }
  }

  function getLiveVariantId(el, fallback) {
    var cartAction = el.closest ? el.closest('cart-action') : null;
    if (cartAction) {
      var liveInput = cartAction.querySelector('.product-variant-id');
      if (liveInput && liveInput.value) {
        return liveInput.value;
      }
    }
    return fallback;
  }

  window.SBWishlist.getArray = getArray;
  window.SBWishlist.normalize = normalize;
  window.SBWishlist.findIndex = findIndex;
  window.SBWishlist.save = save;
  window.SBWishlist.getLiveVariantId = getLiveVariantId;
})();

addEventListener('DOMContentLoaded', (event) => {
  function markActiveButtons() {
    var wishlist_pro = window.SBWishlist.getArray();
    $(".wishlist-custom-action").each(function () {
      var attr = $(this).attr("data-handle");
      if (window.SBWishlist.findIndex(wishlist_pro, attr) >= 0) {
        $(this).addClass('active-wishlist');
        $(this).removeClass('wishlist-custom-action');
      }
    });
    $('.wishlist-counter').text(wishlist_pro.length);
  }
  markActiveButtons();

  jQuery(document).on('click', '.wishlist-custom-action', function (e) {
    e.preventDefault();
    var handle = $(this).attr('data-handle');
    var variantId = window.SBWishlist.getLiveVariantId(this, $(this).attr('data-variant-id') || '');
    var variantTitle = $(this).attr('data-variant-title') || '';
    var productTitle = $(this).attr('data-product-title') || '';
    var price = $(this).attr('data-price') || '';
    var image = $(this).attr('data-image') || '';

    var wishlist_pro = window.SBWishlist.getArray();
    if (window.SBWishlist.findIndex(wishlist_pro, handle) === -1) {
      wishlist_pro.push({
        handle: handle,
        variantId: variantId,
        variantTitle: variantTitle,
        productTitle: productTitle,
        price: price,
        image: image
      });
      window.SBWishlist.save(wishlist_pro);
    }

    $(this).removeClass('wishlist-custom-action').addClass('active-wishlist');
    $(".wishlist[data-handle='" + handle + "']")
      .addClass('active-wishlist')
      .removeClass('wishlist-custom-action');

    $('.wishlist-counter').text(window.SBWishlist.getArray().length);
  });

  jQuery(document).on('click', '.active-wishlist', function (e) {
    e.preventDefault();
    var to_delete = $(this).attr('data-handle');
    var wishlist_pro = window.SBWishlist.getArray();
    var idx = window.SBWishlist.findIndex(wishlist_pro, to_delete);
    if (idx > -1) {
      wishlist_pro.splice(idx, 1);
      window.SBWishlist.save(wishlist_pro);

      $(this).removeClass('active-wishlist').addClass('wishlist-custom-action');
      $(".wishlist[data-handle='" + to_delete + "']")
        .removeClass('active-wishlist')
        .addClass('wishlist-custom-action');

      $('.wishlist-counter').text(wishlist_pro.length);
    }
  });
});
